import {
  DebitCardFundingOptionsResult,
  DebitCardFundingOptionsResultTypenames,
  DebitCardFundingOptionsSuccess,
} from '@varo/graphql-schema-types';
import DebitCardFundingOptions from 'services/graphql/queries/MoveMoney/DebitCardFundingOptions';
import { useQuery } from 'urql';

interface DebitCardFundingOptions {
  debitCardFundingOptions: DebitCardFundingOptionsResult;
}

export const useDebitCardOptions = () => {
  const [{ data, fetching, error }] = useQuery<DebitCardFundingOptions>({
    query: DebitCardFundingOptions,
    requestPolicy: 'network-only',
  });

  const debitCardFundingSuccessResults:
    DebitCardFundingOptionsResult | undefined =
    data?.debitCardFundingOptions as DebitCardFundingOptionsSuccess;

  const maxCardFundingAmount = (
    data?.debitCardFundingOptions as DebitCardFundingOptionsSuccess
  )?.maxAmount;

  const minCardFundingAmount = (
    data?.debitCardFundingOptions as DebitCardFundingOptionsSuccess
  )?.minAmount;

  const debitCardFundingOptionsType: DebitCardFundingOptionsResultTypenames =
    data?.debitCardFundingOptions
      .__typename as DebitCardFundingOptionsResultTypenames;

  return {
    debitCardFundingSuccessResults: debitCardFundingSuccessResults,
    debitOptionError: error,
    loading: fetching,
    maxCardFundingAmount: maxCardFundingAmount,
    minCardFundingAmount: minCardFundingAmount,
    debitCardFundingOptionsType: debitCardFundingOptionsType,
    isDcfAvailable:
      debitCardFundingOptionsType ===
      DebitCardFundingOptionsResultTypenames.DebitCardFundingOptionsSuccess,
  };
};
